(() => {
  const GIFT_VARIANT_ID = 44363867128072;
  const RACKET_PRODUCT_TYPE = 'Pala de padel';
  const GIFT_PROPERTY = '_top_force_free_cover';
  const SOURCE_ID = 'top-force-free-cover';
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let scheduled = null;

  const cartUrl = (path) => `${root}${path}`;

  async function request(path, options = {}) {
    const response = await nativeFetch(cartUrl(path), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`Cart request failed (${response.status})`);
    }

    return response.json();
  }

  function racketQuantity(cart) {
    return cart.items.reduce(
      (total, item) => total + (item.product_type === RACKET_PRODUCT_TYPE ? item.quantity : 0),
      0,
    );
  }

  function managedGiftLines(cart) {
    return cart.items.filter(
      (item) =>
        Number(item.variant_id) === GIFT_VARIANT_ID &&
        item.properties?.[GIFT_PROPERTY] === 'true',
    );
  }

  function announce(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: SOURCE_ID,
          data: {},
        },
      }),
    );
  }

  async function syncGift() {
    if (syncing) return;
    syncing = true;

    try {
      let cart = await request('cart.js', { method: 'GET', headers: {} });
      const desiredQuantity = racketQuantity(cart);
      const giftLines = managedGiftLines(cart);
      let changed = false;

      if (desiredQuantity > 0 && giftLines.length === 0) {
        await request('cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [
              {
                id: GIFT_VARIANT_ID,
                quantity: desiredQuantity,
                properties: { [GIFT_PROPERTY]: 'true' },
              },
            ],
          }),
        });
        changed = true;
      } else if (giftLines.length > 0) {
        const [primaryGift, ...duplicates] = giftLines;

        if (primaryGift.quantity !== desiredQuantity) {
          await request('cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: primaryGift.key, quantity: desiredQuantity }),
          });
          changed = true;
        }

        for (const duplicate of duplicates) {
          await request('cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: duplicate.key, quantity: 0 }),
          });
          changed = true;
        }
      }

      if (changed) {
        cart = await request('cart.js', { method: 'GET', headers: {} });
        announce(cart);
      }
    } catch (error) {
      console.error('[Top Force] No se pudo sincronizar la funda gratuita.', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(syncGift, 120);
  }

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const requestUrl = String(args[0]?.url || args[0] || '');

    if (
      !syncing &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(requestUrl)
    ) {
      scheduleSync();
    }

    return response;
  };

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.sourceId !== SOURCE_ID) scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGift, { once: true });
  } else {
    syncGift();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) scheduleSync();
  });
})();
